var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUpArrowz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3906 12.0422C24.3906 5.41482 19.018 0.0422355 12.3906 0.0422358C5.76321 0.0422361 0.390624 5.41482 0.390624 12.0422C0.390625 18.6697 5.76321 24.0422 12.3906 24.0422C19.018 24.0422 24.3906 18.6697 24.3906 12.0422Z",
    fill: "#97144D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2905 11.0494L14.937 13.6958C15.1322 13.8911 15.4488 13.8911 15.6441 13.6958C15.8393 13.5006 15.8393 13.184 15.6441 12.9887L12.6441 9.98873C12.4488 9.79347 12.1322 9.79347 11.937 9.98873L8.93697 12.9887C8.74171 13.184 8.74171 13.5006 8.93697 13.6958C9.13224 13.8911 9.44882 13.8911 9.64408 13.6958L12.2905 11.0494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpArrowz);
export default __webpack_public_path__ + "static/media/ic_up_arrowz.307d06fdf87770e64fa4a4385f37f649.svg";
export { ForwardRef as ReactComponent };